module.exports = __webpack_public_path__ + "img/aktive_garde.04f1e0d0.svg";